export enum CompositeChipsContainer {
    top,
    bottom,
}
